import React, { useState } from 'react';

function AppSidebar({ children }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleSidebar();
        }
    };

    return (
        <div className="app-sidebar">
            <div className="sidebar-collapse">
                <div className="mobile-wrapper">
                    <h2 className="toggle-heading">Filters</h2>

                    <button
                        className="btn sidebar-toggle"
                        aria-controls="sidebar-collapse-wrapper"
                        aria-expanded={isOpen}
                        onClick={toggleSidebar}
                        onKeyDown={handleKeyDown}
                        type="button"
                    >
                        <span className="sr-only">Toggle Sidebar</span>
                        <svg className="btn-icon toggle-icon" width="16" height="16" viewBox="0 0 16 16" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
                            <title>Toggle Menu Icon</title>
                            <path fillRule="evenodd" clipRule="evenodd" d="M2 3.75C2 3.33579 2.33579 3 2.75 3H13.25C13.6642 3 14 3.33579 14 3.75C14 4.16421 13.6642 4.5 13.25 4.5H2.75C2.33579 4.5 2 4.16421 2 3.75ZM2 8C2 7.58579 2.33579 7.25 2.75 7.25H13.25C13.6642 7.25 14 7.58579 14 8C14 8.41421 13.6642 8.75 13.25 8.75H2.75C2.33579 8.75 2 8.41421 2 8ZM2 12.25C2 11.8358 2.33579 11.5 2.75 11.5H7.25C7.66421 11.5 8 11.8358 8 12.25C8 12.6642 7.66421 13 7.25 13H2.75C2.33579 13 2 12.6642 2 12.25Z" />
                        </svg>
                    </button>
                </div>

                <div
                    className={`collapse-wrapper ${isOpen ? '' : 'closed'}`}
                    id="sidebar-collapse-wrapper"
                    aria-hidden={!isOpen}
                >
                    {children}
                </div>
            </div>
        </div>
    );
}

export default AppSidebar;
